import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import PageBar from "../../components/common/PageBar";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import MessageDialog from "../../components/common/MessageDialog";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";

const PdiMenuManagementPage = () => {
  const navigate = useNavigate();
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const pageSize = 10;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [datas, setDatas] = useState([]);
  const [checkMenus, setCheckMenus] = useState([]);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/pdimenu/view", {
        level: 2,
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setTotalCount(response.data.totalCount);
        setDatas(response.data.content);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  const handleCheckValue = (e) => {
    if (e.target.checked) {
      setCheckMenus((checkMenus) => [...checkMenus, e.target.value]);
    } else {
      setCheckMenus((checkMenus) =>
        checkMenus.filter((menu) => menu !== e.target.value)
      );
    }
  };

  const handleAddMenu = () => {
    navigate("/manage/pdimenu/edit");
  };

  const handleDeleteCode = () => {
    setIsDialogOpen(true);
  };

  const handleCancel = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = () => {
    if (!checkMenus) {
      return;
    }

    api
      .post("/manage/pdimenu/delete", {
        ids: checkMenus,
      })
      .then(() => {
        loadContentData();
        setCheckMenus([]);
      })
      .catch(() => {});

    setIsDialogOpen(false);
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0463")]}></BreadCrumbDiv>

      <ButtonWrapDiv className="btn_top">
        {menuAuthInfo.reg && (
          <FunctionButton
            value={t("L0321")}
            onClick={handleAddMenu}
          ></FunctionButton>
        )}
        {menuAuthInfo.del && (
          <FunctionButton
            className="bg_gray"
            value={t("L0091")}
            onClick={handleDeleteCode}
          ></FunctionButton>
        )}
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "8%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "auto" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>Menu ID</th>
                <th>Menu Desc</th>
                <th>URL</th>
                <th>USE YN</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={11} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      <input
                        type="checkbox"
                        name="menu-check"
                        id={`menu-check-${data["id"]}`}
                        value={`${data["id"]}`}
                        onChange={handleCheckValue}
                        checked={checkMenus.includes(data["id"].toString())}
                      />
                      <label htmlFor={`menu-check-${data["id"]}`}></label>
                    </td>
                    <td>
                      {`${data.majorCode}_${data.middleCode}_${data.minorCode}`}
                    </td>
                    <td>{data.desc}</td>
                    <td>{data.url}</td>
                    <td>{data.useYn ? "True" : "False"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>

      {isDialogOpen && (
        <MessageDialog title={"L0339"} message={t("L0096")}>
          <FunctionButton
            className="bg_gray"
            value={t("L0005")}
            onClick={handleCancel}
          ></FunctionButton>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};
export default PdiMenuManagementPage;
